import React, { useState } from "react";
import axios from 'axios';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import UploadProductImage from "./UploadProductImage";



const AddProduct = ({ isAuthenticatedAd }) => {
    const [active, setActive] = useState('Product Information');
    const [disableSave, setDisableSave] = useState(true);


    const { userId, userName, } = useSelector(state => state.user);

    const { apiUrl } = useSelector(state => state.api);


    const changeSelection = (e) => {
        setActive(e.target.innerText);

    }


    let [addInfoProduct, setAddInfoProduct] = useState({
        product_name: "",
        product_price: "",
        product_color: "",
        product_size: "",
        product_quantity: "",
        product_detail: "",
        product_img: ""
    });

    const AddInfoProduct = async (e) => {
        e.preventDefault()
        const data = { ...addInfoProduct };
        try {
            await axios.post(`${apiUrl}/dashboard/addproduct`, data, {
                headers: { token: localStorage.getItem('token') }
            });
            window.location.href = '/dashboard/addproduct/';

        } catch (err) {
            console.error(err.message);

        }
    }

    const handleChangeInfoUser = (event) => {
        setAddInfoProduct({
            ...addInfoProduct,
            [event.target.name]: event.target.value,
        });
    };

    return (
        <>
            {(isAuthenticatedAd && isAuthenticatedAd !== "user") ?
                (<div className="container-myaccount justify-content-center align-items-center" >
                    <h2 className="text-center">Welcome to Dashboard</h2>
                    <h5 className="text-center">Manage Product information for your Store
                    </h5>

                    <div className="row">

                        <div className="col-md-2 text-left">
                            <div className="item-list ">
                                <h4>Add Product</h4>
                                <div className="bg-light ">
                                    <Link to="/dashboard/addproduct" className="text-decoration-none text-reset">
                                        <div className={active === 'Product Information' ? 'item active' : 'item'} onClick={changeSelection}>Product Information</div>
                                    </Link>
                                </div>

                                <div className="bg-light ">
                                    <Link to="/dashboard/productsmanagement" params={active} className="text-decoration-none text-reset">
                                        <div className={active === 'Go Back Management' ? 'item active' : 'item'} onClick={changeSelection}>Go Back Management</div>
                                    </Link>
                                </div>

                                {/* <div className="bg-light">
                                    <Link to="/myaccount/password" className="text-decoration-none text-reset">
                                        <div className={active === 'Change password' ? 'item active' : 'item'} onClick={changeSelection}>Change password</div>
                                    </Link>
                                </div>
                                <div className="bg-light">
                                    <Link to="/myaccount/placeorders" className="text-decoration-none text-reset">
                                        <div className={active === 'Orders' ? 'item active' : 'item'}
                                            onClick={(e) => { changeSelection(e); }}
                                        >Orders</div>
                                    </Link>
                                </div> */}

                            </div>
                        </div>
                        {/* Profile */}
                        {/* Change password */}
                        {/* Orders*/}

                        <div className="col-md-10 bg-light p-2">
                            <div className="row ">
                                <div class="col-md-6  text-center p-4 ">
                                    <UploadProductImage setDisableSave={setDisableSave} setAddInfoProduct={setAddInfoProduct}
                                    />

                                </div>
                                <div class="col-md-6 text-center border-start border-5">

                                    <form onSubmit={(e) => AddInfoProduct(e)}>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="name" class="form-label">Name:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="name" name="product_name"
                                                    value={addInfoProduct.product_name}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="name" class="form-label">Price:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="name" name="product_price"
                                                    value={addInfoProduct.product_price}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="text" class="form-label">Size:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="productsize" name="product_size"
                                                    value={addInfoProduct.product_size}
                                                    onChange={handleChangeInfoUser}

                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="phone" class="form-label">Color:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="tel" class="form-control" id="productcolor" name="product_color"
                                                    value={addInfoProduct.product_color}
                                                    onChange={handleChangeInfoUser}
                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Quantity:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input class="form-control" id="productquantity" name="product_quantity" type="number"
                                                    value={addInfoProduct.product_quantity}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                ></input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Product details:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <textarea class="form-control" id="productdetail" name="product_detail"
                                                    value={addInfoProduct.product_detail}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                >
                                                </textarea>
                                            </div>
                                        </div>

                                        {/* <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Image:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input class="form-control" id="inputState" name="product_img"
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                    value={addInfoProduct.product_img}

                                                >
                                                </input>
                                            </div>
                                        </div> */}

                                        <div className="col-11 d-flex justify-content-end m-2">

                                            <button type="submit" className="btn btn-primary"
                                                disabled={disableSave}
                                            >Save</button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div >) : (
                    <div className="container-not">
                        <div className="d-flex justify-content-center align-items-center">
                            <img src="/frusti.jpg" alt="Not Authorized" class="notAuthor" />
                        </div>
                    </div>
                )
            }
        </>
    )
}
export default AddProduct;